import React, { Component } from "react";

class Events extends Component {
    constructor() {
        super();
        this.state ={

        }
    }

    render() {
        return (
            <div>
                events comming soon
            </div>
        );
    }
}

export default Events;